// Which Soch garment photo stands beside which part of the page.
// Each entry is [photo, caption title, caption line].
const img = (n) => `${process.env.PUBLIC_URL || ''}/img/${n}.jpg`;

export const FIXED_PHOTOS = {
  intro:  ['p08', 'From the Soch collection', 'Pink saree, woven zari'],
  status: ['p11', 'Check your application', 'Raspberry kaftan, mirror work'],
  resume: ['p09', 'Send us your resume', 'Sap green kaftan, beaded front'],
  life:   ['p07', 'Life at Soch', 'Indigo cloth, embroidered band'],
  foot:   ['p06', 'Soch', 'Olive anarkali, embroidered hem'],
};

// Known departments.
const DEPT_PHOTOS = {
  'E-commerce & Digital':     ['p13', 'Indigo dress material, embroidered yoke'],
  'CCTV Surveillance':        ['p03', 'Maroon kurta set, printed panel'],
  "CEO & Chairman's Office":  ['p02', 'Ivory saree, zari border'],
  'Visual Merchandising':     ['p01', 'Black floral lehenga, embellished blouse'],
  'Other':                    ['p10', 'Red dress material, thread embroidery'],
  'Buying & Planning':        ['p05', 'Fuchsia dress material, embroidered yoke'],
  'Corporate & Strategy':     ['p14', 'Blue saree, silver zari border'],
  'Marketing & Brand':        ['p12', 'Mustard co-ord set, embroidered hem'],
};

// Departments we have not matched to a photo take the next one in this rotation.
const FALLBACK = [
  ['p04', 'Red kaftan set, zari floral yoke'],
  ['p11', 'Raspberry kaftan, mirror work'],
  ['p09', 'Sap green kaftan, beaded front'],
  ['p07', 'Indigo cloth, embroidered band'],
  ['p08', 'Pink saree, woven zari'],
  ['p06', 'Olive anarkali, embroidered hem'],
];

// Build the key -> [file, title, line] map for the page, given the departments the API returned.
export function buildPhotoMap(depts) {
  const map = { ...FIXED_PHOTOS };
  let spare = 0;
  depts.forEach((d) => {
    const known = DEPT_PHOTOS[d];
    if (known) { map[d] = [known[0], d, known[1]]; return; }
    const f = FALLBACK[spare % FALLBACK.length];
    spare += 1;
    map[d] = [f[0], d, f[1]];
  });
  return map;
}

export function photoUrl(file) { return img(file); }

// Photo used behind the standalone /apply page.
// Caption names the garment only: the page's own heading already says "Send us your resume".
export const APPLY_PHOTO = ['p09', 'From the Soch collection', 'Sap green kaftan, beaded front'];

export const LEGAL = {
  privacy: 'https://www.soch.com/in/privacy-policy',
  terms: 'https://www.soch.com/in/terms-conditions',
};
